import { Flex, Box } from 'components/ui';
import { Col, Row } from 'react-grid-system';
import RoundedBox from 'components/Traits/RoundedBox';
import TraitsGallery from 'components/TraitsGallery';
import lightningIcon from 'img/lightning.svg';
import { TRAITS_MEDIA_FILES } from '../../constants';

interface EffectsProps {}

const Effects: React.FC<EffectsProps> = () => {
  return (
    <Row>
      <Col xs={12} sm={12} md={5}>
        <RoundedBox>
          <TraitsGallery
            items={[
              {
                title: 'Light Pulse',
                content: (
                  <Box>
                    <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                      <source
                        src={TRAITS_MEDIA_FILES.effects.lightPulse}
                        type="video/mp4"
                      ></source>
                    </video>
                  </Box>
                ),
                description:
                  'When the note hits, the background color changes and then immediately transitions to the default color.',
              },
              {
                title: 'Light Flickering',
                content: (
                  <Box>
                    <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                      <source
                        src={TRAITS_MEDIA_FILES.effects.flicker}
                        type="video/mp4"
                      ></source>
                    </video>
                  </Box>
                ),
                description: 'The light emitted by this note flickers like a neon sign.',
              },
              {
                title: 'Light Waves',
                content: (
                  <Box>
                    <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                      <source
                        src={TRAITS_MEDIA_FILES.effects.lightWave}
                        type="video/mp4"
                      ></source>
                    </video>
                  </Box>
                ),
                description: 'Waves of light travel through the note segments.',
              },
              {
                title: 'Orbiting Particles',
                content: (
                  <Box>
                    <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                      <source
                        src={TRAITS_MEDIA_FILES.effects.particles}
                        type="video/mp4"
                      ></source>
                    </video>
                  </Box>
                ),
                description: 'Light emitting particles circle around the note when it’s playing.',
              },
              {
                title: 'Sphere Particles',
                content: (
                  <Box>
                    <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                      <source
                        src={TRAITS_MEDIA_FILES.effects.spheres}
                        type="video/mp4"
                      ></source>
                    </video>
                  </Box>
                ),
                description: 'Similar to the orbiting particles, but larger sized particles.',
              },
              {
                title: 'Shake',
                content: (
                  <Box>
                    <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                      <source
                        src={TRAITS_MEDIA_FILES.effects.shake}
                        type="video/mp4"
                      ></source>
                    </video>
                  </Box>
                ),
                description: 'When this note hits, the camera starts shaking.',
              },
              {
                title: 'Laser',
                content: (
                  <Box>
                    <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                      <source
                        src={TRAITS_MEDIA_FILES.effects.laser}
                        type="video/mp4"
                      ></source>
                    </video>
                  </Box>
                ),
                description: 'Laser beams are projected from these note segments.',
              },
              {
                title: 'Lightning',
                content: (
                  <Box>
                    <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                      <source
                        src={TRAITS_MEDIA_FILES.effects.lightning}
                        type="video/mp4"
                      ></source>
                    </video>
                  </Box>
                ),
                description: 'Lightning strikes the note when it’s playing.',
              },
            ]}
          />
        </RoundedBox>
      </Col>
      <Col id="effects" xs={12} sm={12} md={7}>
        <RoundedBox minHeight="510px">
          <Flex mb={3}>
            <img src={lightningIcon} width="20px" alt="lightning icon" />
            <Box ml={3} fontWeight="bold" fontSize={3}>
              Effects
            </Box>
          </Flex>

          <Box>
            <ul>
              <li>
                Effects are contextual traits to each music Clip. They will be activated when a note
                from a specific Clip is played.{' '}
              </li>
              <li>
                There are a total of 8 different effects segmented into categories:
                <ul>
                  <li>Light: 1) Pulse; 2) Flicker; 3) Waves</li>
                  <li>Particles: 4) Orbiting; 5) Sphere</li>
                  <li>Special: 6) Shake; 7) Laser; 8) Lightning </li>
                </ul>
              </li>
              <li>Each Futura NFT could have any combination, ranging from 0 to all 8. </li>
            </ul>
          </Box>
        </RoundedBox>
      </Col>
    </Row>
  );
};

export default Effects;
